import React from "react";
import logo from "./logo.png";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp, FaGlobe, FaYoutube, FaMapMarkerAlt , FaFilePdf, FaDownload  } from "react-icons/fa";
const DigitalPlatinumCard = () => {
  return (
    <div className="as-card-wrapper">
      <div className="as-card">
        <div className="top-red-bar"></div>

        <div className="as-header">
          <img src={logo} alt="Logo" className="as-logo" />

          <h1>Salasar Engineers</h1>

          <p>
            <strong>Manufacturer:</strong> Diesel Generator, Silent Generator,
            Power Generator, Electrical Panel, Acoustic Enclosure Solutions
          </p>
        </div>

        <div className="name-badge">
          <h2>Navin Bansal</h2>
          <span>Proprietor</span>
        </div>

        <div className="dark-section">
          <div className="left-line">
  <div className="icon-box">
    <FaPhoneAlt />
  </div>

  <div className="icon-box">
    <FaEnvelope />
  </div>

  <div className="icon-box whatsapp">
    <FaWhatsapp />
  </div>

  <div className="icon-box">
    <FaGlobe />
  </div>

  <div className="icon-box youtube">
    <FaYoutube />
  </div>

  <div className="icon-box">
    <FaMapMarkerAlt />
  </div>
</div>

          <div className="action-list">
            <a href="tel:+919212123418">
              <span>Click To Call</span>
              <small>9212123418</small>
            </a>

            <a href="mailto:navinkbansal@gmail.com">
              <span>Click To Mail</span>
            </a>

            <a href="https://wa.me/919212123418" target="_blank" rel="noreferrer">
              <span>Click To Whatsapp</span>
            </a>

            <a href="https://www.salasarengineers.com/" target="_blank" rel="noreferrer">
              <span>Visit Our Website</span>
            </a>

            <a href="#" target="_blank" rel="noreferrer">
              <span>Watch Our Video</span>
            </a>

            <a href="https://maps.app.goo.gl/62d5NgHkWsxCsEZB9" target="_blank" rel="noreferrer">
              <span>Visit Our Location</span>
            </a>
          </div>

          <a href="/salasar-catalogue.pdf" download className="pdf-download">
  <div className="pdf-shape d-flex">
    <FaFilePdf className="pdf-icon" />
    {/* <FaDownload className="download-icon" /> */}
  </div>
</a>

          <div className="footer-info">
            <h3>Salasar Engineers</h3>
            <p>
              C-275, Mayapuri Industrial Area , Phase-2, New Delhi-110064, INDIA
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;